import { StorageFile } from "@/@types/app/StorageFile";
import { appApi } from "../api";
import { Banner } from "@/@types/app/Banner";
import { AxiosResponse } from "axios";

export type ImageFileFormData = {
	bannerTypeId: number;
	startDate: string;
	endDate: string;
	fileDescription: string;
	imageFile: File;
};

export type registerBannerData = {
	storageFileId: number;
	bannerTypeId: number;
	startDate: string;
	endDate: string;
};

export async function getBanners() {
	const { data } = await appApi.get<Banner[]>(`/StorageFile/GetBanners`);
	return data || [];
}

export async function getBannersByType(typeId: number) {
	const { data } = await appApi.get<Banner[]>(`/StorageFile/BannerFilterbyType`, { typeId });
	return data || [];
}

export async function getUpdateBanner(banner: Banner) {
	const response = await appApi.post<Banner>(`/StorageFile/UpdateBanner`, { ...banner });
	return { ...response, data: response.data || ({} as Banner) } as AxiosResponse<Banner>;
}

export async function registerBanner(data: ImageFileFormData) {
	const response = await appApi.post<StorageFile>(`/StorageFile/RegisterBanner`, data, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return {
		...response,
		data: response.data || ({} as StorageFile),
	} as AxiosResponse<StorageFile>;
}

export async function deleteBanner(banner: Banner) {
	const response = await appApi.post(`/StorageFile/DeleteBanner`, {
		bannerId: banner.id,
	});
	return response;
}
